const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.16,121.19C376.37,72.34,478.42,8.47,593.67,34.61c35.74,8.1,68.26,28.36,90.24,57.82,58.78,78.77,54,199.41,22.07,288.08a161.7,161.7,0,0,1-16.07,33.13c-32.42,50-87,52.38-139.72,37.92C505.6,439.32,466.1,426.73,420,439.17c-25.51,6.9-50.23,16.37-75.64,23.58-34.61,9.82-70.28,16.49-106.32,17.17C142.75,481.7,33.84,433.07,25.39,326.6a169,169,0,0,1-.33-20.75C27,263.35,41,220.78,80,198.72c39.14-22.19,85.58-31,127.46-46.7C231.22,143.07,254.32,132.44,277.16,121.19Z",
    style: {
      fill: "#F2F2D8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.16,121.19C376.37,72.34,478.42,8.47,593.67,34.61c35.74,8.1,68.26,28.36,90.24,57.82,58.78,78.77,54,199.41,22.07,288.08a161.7,161.7,0,0,1-16.07,33.13c-32.42,50-87,52.38-139.72,37.92C505.6,439.32,466.1,426.73,420,439.17c-25.51,6.9-50.23,16.37-75.64,23.58-34.61,9.82-70.28,16.49-106.32,17.17C142.75,481.7,33.84,433.07,25.39,326.6a169,169,0,0,1-.33-20.75C27,263.35,41,220.78,80,198.72c39.14-22.19,85.58-31,127.46-46.7C231.22,143.07,254.32,132.44,277.16,121.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.54,292s-18.15-19-28.06-19-23.93,14.86-28.06,16.51-15.68-9.08-25.58-6.6-19.81,16.5-22.28,17.33-17.34-5-23.94-1.65-16.39,7.29-16.39,7.29H338.91l-5-10.59s-1.65-11.56-13.2-14S307.54,292,307.54,292Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,37.84s-18.16-19-28.06-19S123.5,33.71,119.37,35.37s-15.68-9.08-25.58-6.61S74,45.27,71.51,46.09s-17.33-5-23.94-1.65-16.39,7.3-16.39,7.3H206.86l-5-10.6s-1.66-11.55-13.21-14S175.5,37.84,175.5,37.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.64,105.52s-18.15-19-28.06-19S656.65,101.39,652.52,103s-15.68-9.08-25.58-6.6-19.81,16.5-22.28,17.33-17.34-5-23.94-1.65-16.39,7.29-16.39,7.29H740l-5-10.59s-1.65-11.56-13.2-14S708.64,105.52,708.64,105.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.77,117.37h0a3.1,3.1,0,0,1-3.11-3.1V94.09a3.1,3.1,0,0,1,3.1-3.11h0a3.11,3.11,0,0,1,3.11,3.11v20.18A3.1,3.1,0,0,1,237.77,117.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.76,148.93h0a3.1,3.1,0,0,1-3.1-3.1V125.65a3.11,3.11,0,0,1,3.11-3.11h0a3.1,3.1,0,0,1,3.1,3.11v20.18A3.1,3.1,0,0,1,237.76,148.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.76,192.39h0a3.1,3.1,0,0,1-3.11-3.1V169.11a3.1,3.1,0,0,1,3.1-3.1h0a3.1,3.1,0,0,1,3.1,3.1v20.18A3.1,3.1,0,0,1,237.76,192.39Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.74,425.49l-148.27,0A13.48,13.48,0,0,1,63,412L63,75.73A13.47,13.47,0,0,1,76.52,62.26l148.27,0a13.48,13.48,0,0,1,13.47,13.48l0,336.26A13.48,13.48,0,0,1,224.74,425.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.14,
    y: 86.21,
    width: 148.98,
    height: 315.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.1 106.05 76.12 106.02 76.16 86.2 225.14 86.22 225.1 106.05",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,99.52H176.4a4.2,4.2,0,0,1-4.2-4.2h0a4.19,4.19,0,0,1,4.2-4.19h34.25a4.18,4.18,0,0,1,4.19,4.19h0A4.19,4.19,0,0,1,210.65,99.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.67,99.52h-73a4.19,4.19,0,0,1-4.19-4.2h0a4.18,4.18,0,0,1,4.19-4.19h73a4.18,4.18,0,0,1,4.19,4.19h0A4.19,4.19,0,0,1,160.67,99.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.25,
    y: 138.27,
    width: 66.62,
    height: 124.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.25 262.58 170.33 183 186.06 199.08 203.5 160.43 216.16 175.48 216.86 262.58 150.25 262.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.73,
    cy: 155.12,
    r: 8.38,
    transform: "translate(-16.22 290.74) rotate(-79.48)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.39,
    y1: 127.57,
    x2: 216.46,
    y2: 127.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.37,127.63v-5.26a3.46,3.46,0,0,1,3.39-3.52h20.3a3.45,3.45,0,0,1,3.38,3.52v5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.72,127.63v-5.26a3.45,3.45,0,0,1,3.38-3.52h20.3a3.46,3.46,0,0,1,3.39,3.52v5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,127.63v-5.26a3.46,3.46,0,0,1,3.38-3.52h20.31a3.45,3.45,0,0,1,3.38,3.52v5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.41,127.63v-5.26a3.45,3.45,0,0,1,3.38-3.52h20.3a3.46,3.46,0,0,1,3.39,3.52v5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.57,
    y1: 140.35,
    x2: 143.13,
    y2: 140.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.57,
    y1: 150.05,
    x2: 143.13,
    y2: 150.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.57,
    y1: 159.75,
    x2: 143.13,
    y2: 159.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.57,
    y1: 169.45,
    x2: 143.13,
    y2: 169.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.57,
    y1: 179.15,
    x2: 143.13,
    y2: 179.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.57,
    y1: 188.85,
    x2: 143.13,
    y2: 188.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.39,
    y1: 277.76,
    x2: 214.95,
    y2: 277.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.39,
    y1: 287.46,
    x2: 214.95,
    y2: 287.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.39,
    y1: 297.16,
    x2: 214.95,
    y2: 297.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.39,
    y1: 306.86,
    x2: 214.95,
    y2: 306.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.39,
    y1: 316.56,
    x2: 214.95,
    y2: 316.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.39,
    y1: 326.26,
    x2: 214.95,
    y2: 326.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.18,
    y1: 277.76,
    x2: 139.74,
    y2: 277.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.18,
    y1: 287.46,
    x2: 139.74,
    y2: 287.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.18,
    y1: 297.16,
    x2: 139.74,
    y2: 297.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.18,
    y1: 306.86,
    x2: 139.74,
    y2: 306.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.18,
    y1: 316.56,
    x2: 139.74,
    y2: 316.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.18,
    y1: 326.26,
    x2: 139.74,
    y2: 326.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-647"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 13.58,
    y1: 425.17,
    x2: 732.92,
    y2: 425.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Target--inject-647"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512.39,
    cy: 84.67,
    r: 45.29,
    transform: "translate(232.94 522.41) rotate(-66.83)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.39,
    cy: 84.67,
    r: 36.27,
    transform: "translate(90.21 387.11) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.39,
    cy: 84.67,
    r: 23.22,
    transform: "translate(90.21 387.11) rotate(-45)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.39,
    cy: 84.67,
    r: 13.12,
    transform: "translate(90.21 387.11) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#1a004f",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.29,85.77H450.38v-2.2h60.91a1.1,1.1,0,0,1,1.1,1.1h0A1.1,1.1,0,0,1,511.29,85.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.96 76.86 445.3 77.25 451.67 83.56 432.62 83.56 425.81 76.86 444.96 76.86",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.81,92.22l6.81-6.47h19.05a40.91,40.91,0,0,0-6.76,6.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.39,392.61a14.2,14.2,0,0,0,4.16.14s-.77-1.87-.84-2c-.74-1.29-2.94-3.35-4.57-3a2,2,0,0,0-1.4,2.59A4.13,4.13,0,0,0,16.39,392.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,379.76c-1.67-.05-3.47,2.37-4,3.77,0,.12-.51,2.1-.48,2.1h0c-.29.38-.59.79-.91,1.25-.59.84-1.25,1.8-1.89,2.9a33.82,33.82,0,0,0-1.91,3.62,25,25,0,0,0-1.54,4.32.11.11,0,0,0,0,.05c0-.49-.16-1.85-.18-1.95-.3-1.46-1.74-4.11-3.41-4.29a2,2,0,0,0-2.13,2,4.09,4.09,0,0,0,1.82,3,13.61,13.61,0,0,0,3.86,1.43,34.1,34.1,0,0,0-.75,4.61c-.1.9-.16,1.81-.21,2.73,0-.42-.08-.8-.09-.85-.3-1.46-1.75-4.11-3.41-4.29a2,2,0,0,0-2.13,2,4.12,4.12,0,0,0,1.82,3,13.19,13.19,0,0,0,3.74,1.39c0,.35,0,.71-.05,1.06-.07,1.68-.14,3.37-.25,5,0,.58-.1,1.15-.16,1.72,0-.37-.07-.69-.08-.74-.3-1.46-1.75-4.1-3.41-4.28a2,2,0,0,0-2.13,2,4.14,4.14,0,0,0,1.81,3,12.51,12.51,0,0,0,3.65,1.37c-.08.59-.16,1.17-.26,1.73-.08.38-.13.76-.23,1.14l-.27,1.12c-.2.71-.4,1.44-.61,2.12-.14.48-.29.93-.43,1.39.05-.58.11-1.72.11-1.81a7.73,7.73,0,0,0-1.31-3.65,3.18,3.18,0,0,0-.06-.43A2,2,0,0,0,36,415.79c-1.57.55-2.38,3.45-2.35,4.94,0,.09.14,1,.23,1.64-.11-.34-.21-.68-.33-1-.22-.7-.46-1.39-.72-2.14l-.42-1.07c-.13-.36-.31-.73-.47-1.1-.38-.85-.81-1.68-1.27-2.52a13.12,13.12,0,0,0,3.61-1.67,4.16,4.16,0,0,0,1.59-3.1,2,2,0,0,0-2.28-1.86c-1.65.31-2.89,3.06-3.08,4.54,0,.09,0,1.17,0,1.76-.28-.5-.55-1-.85-1.5-.85-1.44-1.76-2.86-2.66-4.29l-.81-1.31a13.93,13.93,0,0,0,3.74-1.72,4.11,4.11,0,0,0,1.58-3.09,2,2,0,0,0-2.28-1.86c-1.64.31-2.88,3-3.07,4.53,0,.11,0,1.66,0,2.06-.6-1-1.19-1.93-1.73-2.91A36,36,0,0,1,22.44,400a13.86,13.86,0,0,0,3.77-1.72,4.11,4.11,0,0,0,1.58-3.09,2,2,0,0,0-2.28-1.86c-1.64.3-2.88,3.05-3.07,4.53,0,.12,0,1.78,0,2.09a2.72,2.72,0,0,1-.11-.25,25.38,25.38,0,0,1-1.18-4.37c-.15-.82-.25-1.61-.34-2.38a13.73,13.73,0,0,0,3.84-1.28,4.17,4.17,0,0,0,1.92-2.91,2,2,0,0,0-2.07-2.09c-1.66.12-3.2,2.71-3.55,4.16,0,.08-.12.91-.19,1.51,0-.35-.07-.71-.1-1.05-.09-1.26-.1-2.42-.1-3.45,0-.58,0-1.11.05-1.6a13.38,13.38,0,0,0,2.8-2.89,4.18,4.18,0,0,0,.36-3.46A2,2,0,0,0,21,379c-1.42.88-1.59,3.89-1.23,5.33,0,.13.74,2,.76,2l0,0c0,.48-.06,1-.07,1.54,0,1-.05,2.19,0,3.46a36.7,36.7,0,0,0,.4,4.08,26.49,26.49,0,0,0,1.1,4.45s0,0,0,.05c-.29-.39-1.15-1.46-1.22-1.53-1.06-1.06-3.72-2.47-5.21-1.7a2,2,0,0,0-.66,2.87A4.13,4.13,0,0,0,18,401a13.92,13.92,0,0,0,4-.94A34.81,34.81,0,0,0,24,404.32c.42.8.87,1.6,1.34,2.39l-.55-.66c-1.05-1.05-3.72-2.46-5.2-1.7a2,2,0,0,0-.66,2.87A4.09,4.09,0,0,0,22,408.69a13.12,13.12,0,0,0,3.9-.9l.53.91c.87,1.45,1.75,2.89,2.56,4.33.29.5.55,1,.82,1.52l-.47-.57c-1.06-1.05-3.72-2.46-5.21-1.69a2,2,0,0,0-.66,2.86,4.14,4.14,0,0,0,3.15,1.48,12.59,12.59,0,0,0,3.79-.87c.26.53.52,1.06.74,1.59.15.36.31.7.44,1.07L32,419.5c.23.7.46,1.42.66,2.11.15.48.28.93.41,1.39-.28-.5-.85-1.49-.91-1.57-.88-1.19-3.3-3-4.89-2.46a2,2,0,0,0-1.08,2.73,4.12,4.12,0,0,0,2.89,1.94,13.81,13.81,0,0,0,4.08-.32c.21.76.41,1.5.59,2.21l.08.31h1c-.05-.19-.1-.37-.15-.57-.22-.77-.46-1.6-.72-2.44a21.09,21.09,0,0,0,2.2-1.24,14.58,14.58,0,0,0,3.48,1.89c-.24.75-.48,1.48-.72,2.17a1.07,1.07,0,0,0-.07.19h1c.24-.73.48-1.51.71-2.31a13.68,13.68,0,0,0,4.1,0,4.17,4.17,0,0,0,2.74-2.15,2,2,0,0,0-1.3-2.64c-1.62-.41-3.89,1.57-4.69,2.83,0,.07-.46.94-.71,1.49.1-.35.2-.68.3-1,.2-.71.38-1.42.57-2.18.08-.37.16-.75.25-1.13s.14-.78.21-1.17c.14-.92.25-1.86.33-2.8a13.23,13.23,0,0,0,3.93.59,4.09,4.09,0,0,0,3-1.71,2,2,0,0,0-.87-2.8c-1.54-.66-4.09.95-5.07,2.08-.06.07-.67,1-1,1.45q.08-.84.12-1.71c.08-1.67.11-3.36.15-5,0-.52,0-1,0-1.55a13.94,13.94,0,0,0,4.07.64,4.19,4.19,0,0,0,3-1.71,2,2,0,0,0-.88-2.81c-1.54-.65-4.09,1-5.06,2.08-.08.09-1,1.37-1.16,1.71,0-1.14.08-2.27.17-3.38a35.37,35.37,0,0,1,.63-4.47,13.83,13.83,0,0,0,4.09.64,4.12,4.12,0,0,0,3-1.71,2,2,0,0,0-.88-2.81c-1.54-.65-4.09,1-5.06,2.09-.08.09-1,1.46-1.17,1.73,0-.09,0-.18,0-.26a24.93,24.93,0,0,1,1.43-4.3c.32-.77.67-1.49,1-2.18A13.3,13.3,0,0,0,50,392.37,4.13,4.13,0,0,0,53.21,391a2,2,0,0,0-.56-2.89c-1.46-.82-4.17.5-5.26,1.52-.06.05-.6.68-1,1.14.17-.31.33-.63.5-.92.61-1.1,1.25-2.07,1.82-2.93.32-.48.63-.91.92-1.32a13.16,13.16,0,0,0,3.93-.86,4.15,4.15,0,0,0,2.21-2.69A2,2,0,0,0,54,379.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,391s.38-2,.39-2.12c.1-1.48-.6-4.42-2.15-5a2,2,0,0,0-2.6,1.39,4.17,4.17,0,0,0,1,3.34A14.25,14.25,0,0,0,46,391Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.41,360.38c2.18.95,7.5.83,7.51.83s-1.15-3.49-1.25-3.7c-1.17-2.45-4.87-6.49-7.87-6.08a3.59,3.59,0,0,0-2.89,4.5C265.41,358,267.55,359.57,269.41,360.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,375.81c2.26.33,7-1.05,7.39-1.16a64.86,64.86,0,0,0,2.88,8q1,2.26,2.09,4.52c-.43-.64-.83-1.2-.89-1.28-1.77-2.05-6.41-5-9.2-3.78a3.6,3.6,0,0,0-1.59,5.11c1,1.87,3.5,2.8,5.5,3.09s6.12-.79,7.19-1.1c.29.58.56,1.15.85,1.72,1.38,2.74,2.76,5.47,4,8.19.45,1,.86,1.92,1.27,2.88-.38-.56-.71-1-.77-1.1-1.77-2.05-6.41-5-9.2-3.78a3.59,3.59,0,0,0-1.59,5.1c1,1.88,3.5,2.81,5.5,3.1s5.72-.7,7-1.05c.39,1,.78,2,1.12,3,.21.68.47,1.31.64,2s.38,1.36.57,2c.31,1.3.64,2.64.91,3.91.19.88.36,1.73.54,2.58-.44-1-1.33-2.82-1.43-3-1.44-2.3-5.58-5.88-8.52-5.14a3.6,3.6,0,0,0-2.34,4.81c.73,2,3,3.3,5,3.89,2.13.66,6.85.06,7.44,0,.28,1.41.54,2.79.77,4.09.17,1,.33,1.89.47,2.77h1.89c-.18-1-.38-2-.59-3.1-.28-1.44-.61-3-1-4.52a41,41,0,0,0,4.16-2c1.55,1.69,5.53,3.65,6,3.91-.55,1.33-1.09,2.62-1.61,3.83-.28.64-.55,1.24-.82,1.84h2c.15-.38.31-.75.47-1.14.56-1.35,1.13-2.81,1.69-4.31.57.12,5.25,1.07,7.42.58,2-.45,4.37-1.56,5.25-3.52a3.58,3.58,0,0,0-2-5c-2.88-1-7.27,2.3-8.88,4.48-.09.13-1,1.64-1.5,2.61.23-.62.46-1.21.68-1.85.46-1.25.89-2.51,1.34-3.87q.3-1,.6-2c.22-.66.36-1.39.54-2.1.4-1.64.71-3.33,1-5,1.1.4,5,1.76,7.05,1.62s4.55-.88,5.72-2.68a3.59,3.59,0,0,0-1.21-5.21c-2.7-1.39-7.53,1.18-9.45,3.09-.12.12-1.35,1.64-2,2.49.16-1,.32-2,.45-3.09.37-3,.66-6.06,1-9.11.09-.94.19-1.87.29-2.8.39.15,5,1.87,7.28,1.71,2-.14,4.55-.89,5.72-2.68a3.59,3.59,0,0,0-1.21-5.21c-2.69-1.39-7.53,1.17-9.45,3.09-.15.14-1.91,2.34-2.33,2.92.22-2.05.46-4.09.77-6.09a62.9,62.9,0,0,1,1.75-8c.18.07,5,1.89,7.32,1.72,2-.14,4.55-.88,5.72-2.68a3.58,3.58,0,0,0-1.2-5.2c-2.7-1.4-7.54,1.17-9.46,3.08-.15.15-2,2.52-2.35,3,0-.15.07-.31.12-.46a46.08,46.08,0,0,1,3.17-7.59c.69-1.35,1.43-2.6,2.17-3.81.86.43,4.83,2.36,6.94,2.44s4.62-.38,6-2a3.6,3.6,0,0,0-.63-5.31c-2.53-1.68-7.62.34-9.74,2-.11.09-1.18,1.15-2,1.94.35-.54.69-1.1,1-1.61,1.27-1.91,2.55-3.58,3.7-5.06.65-.83,1.27-1.57,1.85-2.25,1.06,0,5.36-.15,7.24-1s3.92-2.47,4.37-4.57a3.59,3.59,0,0,0-3-4.42c-3-.33-6.6,3.81-7.7,6.29-.1.21-1.21,3.73-1.15,3.73h.06c-.57.65-1.17,1.35-1.82,2.13-1.18,1.45-2.5,3.1-3.81,5a63.08,63.08,0,0,0-4,6.31,46,46,0,0,0-3.38,7.61l0,.1c0-.89,0-3.38-.05-3.57-.35-2.69-2.6-7.68-5.59-8.23a3.59,3.59,0,0,0-4.14,3.38c-.17,2.13,1.37,4.27,2.88,5.62,1.71,1.52,6.43,3,6.81,3.11a64.54,64.54,0,0,0-2,8.25c-.29,1.62-.53,3.26-.75,4.92,0-.77,0-1.46,0-1.56-.35-2.69-2.6-7.67-5.59-8.23a3.6,3.6,0,0,0-4.14,3.38c-.17,2.14,1.38,4.28,2.88,5.62s5.54,2.71,6.61,3.05c-.08.63-.17,1.27-.24,1.9-.37,3-.72,6.09-1.15,9.06-.15,1-.34,2.08-.53,3.1,0-.68,0-1.25,0-1.34-.34-2.69-2.6-7.68-5.58-8.23A3.6,3.6,0,0,0,302.6,397c-.17,2.13,1.38,4.27,2.89,5.62s5.15,2.57,6.41,3c-.22,1.05-.44,2.1-.7,3.1-.2.68-.34,1.35-.57,2s-.43,1.33-.65,2c-.45,1.26-.91,2.55-1.39,3.76-.32.85-.65,1.65-1,2.45.16-1,.44-3.08.44-3.26a14,14,0,0,0-1.87-6.78,4.3,4.3,0,0,0-.05-.8,3.58,3.58,0,0,0-4.39-3c-2.93.78-4.79,5.93-4.93,8.63,0,.16.09,1.91.18,3-.15-.63-.29-1.26-.45-1.91-.3-1.3-.65-2.58-1-4-.2-.66-.41-1.33-.61-2s-.48-1.36-.71-2.05c-.58-1.58-1.25-3.16-2-4.74,1.13-.27,5.15-1.29,6.77-2.53s3.31-3.25,3.29-5.39a3.6,3.6,0,0,0-3.88-3.68c-3,.32-5.64,5.13-6.18,7.79,0,.16-.22,2.11-.3,3.18-.43-.94-.85-1.88-1.32-2.83-1.35-2.71-2.8-5.42-4.23-8.13-.44-.83-.87-1.66-1.3-2.49.4-.09,5.21-1.2,7-2.59,1.61-1.23,3.31-3.25,3.3-5.39a3.6,3.6,0,0,0-3.88-3.68c-3,.33-5.64,5.13-6.19,7.79,0,.2-.29,3-.32,3.72-1-1.83-1.88-3.66-2.73-5.51a64.38,64.38,0,0,1-3-7.65c.19,0,5.21-1.18,7.06-2.6,1.6-1.23,3.31-3.25,3.29-5.39a3.59,3.59,0,0,0-3.88-3.68c-3,.33-5.63,5.14-6.18,7.79,0,.21-.32,3.23-.33,3.78,0-.15-.11-.31-.15-.46a46.43,46.43,0,0,1-1.54-8.08c-.17-1.5-.24-3-.29-4.37,1-.11,5.32-.7,7.13-1.79s3.65-2.87,3.87-5a3.6,3.6,0,0,0-3.46-4.08c-3,0-6.16,4.49-7,7.06,0,.15-.35,1.62-.55,2.7,0-.64,0-1.3,0-1.91,0-2.29.14-4.39.29-6.25.09-1.06.19-2,.3-2.91.88-.6,4.39-3.08,5.47-4.85s1.91-4.23,1.12-6.22a3.59,3.59,0,0,0-4.94-2c-2.7,1.39-3.41,6.82-3,9.5,0,.23,1.06,3.77,1.1,3.74l.06,0c-.12.86-.24,1.78-.35,2.79-.18,1.86-.37,4-.43,6.27a63.27,63.27,0,0,0,.18,7.44,46.63,46.63,0,0,0,1.38,8.21l0,.1c-.48-.75-1.88-2.8-2-2.95-1.77-2.05-6.4-5-9.2-3.78a3.59,3.59,0,0,0-1.59,5.1C266.77,374.59,269.24,375.52,271.25,375.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.3,361.55c.05,0,1-3.54,1-3.77.37-2.69-.48-8.1-3.21-9.42a3.6,3.6,0,0,0-4.89,2.17c-.74,2,.19,4.48,1.29,6.18C318.79,358.71,323.3,361.55,323.3,361.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-planes--inject-647"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "624.5 162.33 624.08 163.47 619.01 173.99 670.03 165.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.34 173.55 624.5 162.33 670.03 165.19 629.34 173.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.03 165.19 635.94 142.75 628.33 158.42 670.03 165.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.03 165.19 629.34 173.55 628.33 158.42 670.03 165.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.1,198.12s.35.39,1,1.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.29,201.27c13.07,12.06,65.24,51.9,134.74-3.81,80.63-64.64-14.66-138.6-66-128.61s-42.64,90.62,38,106c79.76,15.16,143.87-26.41,235.56-15.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2.9891300201416016,2.9891300201416016"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.11,159.29l1.48.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "501.97 313.52 488.48 296.61 517.26 273.27 501.97 313.52",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.48 296.61 486.39 290.29 517.26 273.27 488.48 296.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.26 273.27 485.57 292.14 472.55 274.98 517.26 273.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.83,175.27s44.13,16.86,64,77.35,70.75,96.15,160.31,40.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.85,249s4.5,14.76,4.5,16.27c0,1.28-2.94,12.69-3,17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,206.06l3.38,31.51a10.68,10.68,0,0,0,12.75,9.32c22.41-4.6,72.45-14,103.07-13.54,40.38.65,76.89,21.05,76.89,21.05L283.72,236a321,321,0,0,0-12.93-83.85l-5.29-18S237.22,165.49,196,178.58c-31,9.86-77.22,14.17-98.15,15.7A10.66,10.66,0,0,0,88,206.06Z",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,138.44l-.27-.93S237.22,168.86,196,182c-2.22.71-4.53,1.38-6.9,2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.75,186.35c-7,1.63-14.35,3.06-21.71,4.3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.75,260.51a4.58,4.58,0,0,1-.53,0,6.14,6.14,0,0,1-6.27-6l-.38-18.37A314.74,314.74,0,0,0,264.9,153.9l-5.3-18a6.15,6.15,0,1,1,11.8-3.46l5.29,18a327.22,327.22,0,0,1,13.17,85.46l.37,18.37A6.14,6.14,0,0,1,284.75,260.51Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.88,186.78c-24.27,4.25-49.19,6.49-63,7.5A10.66,10.66,0,0,0,88,206.06l3.38,31.51a10.68,10.68,0,0,0,12.75,9.32c13.85-2.84,38.24-7.53,62.08-10.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.79,238.41s9.81,19.94,11.34,21.77a5.92,5.92,0,0,0,2.76,1.53,12.31,12.31,0,0,1,6.59,5c7,10.61,24.91,37.72,25.82,38.69,1.13,1.21,3.91,2.25,5.45,1.08s13-12.39,12.13-17.29-2.36-3.41-4.92-5.47c-2.05-1.66-10-15.85-13-21.32a4,4,0,0,1,.16-4.18l2.67-4.06s-11.67-9.4-11.85-11,4.69-2.84,4.85-4.52-4.15-7.55-4.15-7.55Z",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.52,248l8.56,3.15a.54.54,0,0,1,.25.82l-1.54,2.16Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.23,
    y1: 256.01,
    x2: 137.76,
    y2: 257.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.94,
    y1: 243.08,
    x2: 142.36,
    y2: 254.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.6,
    y: 209.67,
    width: 9.54,
    height: 6.07,
    transform: "translate(-21.96 15.58) rotate(-6.13)",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36,282.24a2.81,2.81,0,0,0,.24,1.49c1.25,1.75,4.25,14,4.5,15.27a42.49,42.49,0,0,1-.75,10.25c-.75,4-3.75,14.27-3.75,14.27l30.53,9.76s7.25-14.52,9-17.52,7-10.76,8.26-16a69.17,69.17,0,0,0,1.5-11.26s4-3.26,3.51-5.51a13.43,13.43,0,0,0-2.76-4.75s.5-4.26-1-6.51-3.75-4.5-4.25-5.25.75-7.76-2.25-9.26a17.36,17.36,0,0,0-5-1.75s.5-4.26-2.75-6.51-7.26-2.5-10.26.25-16.26,17.27-16.26,17.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.36,270.22s.75,3.75,1.5,4.5-1.5,11.26-1.5,11.26",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "173.13 255.46 167.63 258.71 161.87 265.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.39,
    y1: 266.47,
    x2: 173.63,
    y2: 271.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.64,
    y1: 278.23,
    x2: 179.89,
    y2: 281.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.12,273.22a6.4,6.4,0,0,0,0,4.76l1,2.75",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.38,278.73s-2.75,2-1.75,4.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 313.64 175.03 328.32 168.94 347.29 128.13 328.68 134.22 313.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.85 324.77 174.96 342.76 162.55 398.55 101.95 398.55 128.85 324.77",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles-2--inject-647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.41,191.91c-13.19,0-23.89,8.3-23.89,18.55a15.34,15.34,0,0,0,3,9l-8,13.35,12.76-8.67a27.89,27.89,0,0,0,16.17,4.9c13.2,0,23.9-8.31,23.9-18.55S631.61,191.91,618.41,191.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56,210.09a2.49,2.49,0,1,1-2.49-2.48A2.48,2.48,0,0,1,613.56,210.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.27,210.09a2.49,2.49,0,1,1-2.49-2.48A2.48,2.48,0,0,1,620.27,210.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627,210.09a2.49,2.49,0,1,1-2.49-2.48A2.48,2.48,0,0,1,627,210.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692,238.13c0-10.25-10.7-18.55-23.9-18.55s-23.9,8.3-23.9,18.55c0,8.86,8,16.26,18.69,18.11l1.43,8.62,6.46-8.3C682.71,255.53,692,247.67,692,238.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.76,238.06a2.49,2.49,0,1,1-2.49-2.49A2.48,2.48,0,0,1,663.76,238.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667.98,
    cy: 238.06,
    r: 2.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.18,238.06a2.49,2.49,0,1,1-2.49-2.49A2.48,2.48,0,0,1,677.18,238.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.48,200.78a19.37,19.37,0,0,0-13.19,33.58l-3.75,8.11,7.25-5.51a19.39,19.39,0,1,0,9.69-36.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.14,212.81a5.47,5.47,0,0,0-7.74,0l-2.09,2.09-2.09-2.09a5.47,5.47,0,0,0-7.73,7.73l9.79,9.79,0,0,0,0,9.79-9.79A5.47,5.47,0,0,0,501.14,212.81Z",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters-2--inject-647"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 685.8,
    y: 339.72,
    width: 5.07,
    height: 85.45,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.91,
    y: 339.72,
    width: 5.07,
    height: 85.45,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.46,
    y: 339.72,
    width: 5.07,
    height: 26.92,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.81,
    y: 359.99,
    width: 205.16,
    height: 7.63,
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.81,
    y: 320.91,
    width: 205.16,
    height: 25.34,
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.49,
    y: 367.76,
    width: 5.07,
    height: 57.41,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.18,
    y: 367.76,
    width: 5.07,
    height: 57.41,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.45,301.14s-3.58.37-4.81,4.77-4.4,31.58-2.2,33,7.71-2.33,8.08-5.14,2.32-18.73,2.32-18.73S637.69,300,635.45,301.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.66,286.1s-.21,7.47.1,8,2.22,2.32,7.06,3.23,6.87,1.31,7.67,6.15.51,21.5,1,22.21,6,11.4,6.06,19.07-3.94,12.92-6.66,14.13a21.07,21.07,0,0,1-7.27,1.42H640.4s-1.72-8-.41-14.54,2.73-12.71,2.42-13.62-1-7.27-2-10-4-8.68-4.75-12.61a34,34,0,0,1-.2-8.38s8.48-.81,9.79-2.52-.5-8.18-.5-8.18Z",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.22,299.71a13.11,13.11,0,0,0,8.78,4.16c4.85.43,8.55-4.42,10.26-7.2-3-.95-4.26-2.19-4.5-2.59s-.1-8-.1-8l-12.92,4.34s1.81,6.46.5,8.18A4.39,4.39,0,0,1,643.22,299.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.75,288.22a26.93,26.93,0,0,0,.41,4.75c.4,1.71.8,4.13-.31,5.24s-3.63,2.73-1.61,4,4.24.91,3.73,2-4.84.71-2.62,4.44,7.87,3.84,7.57,4.74-2.83.21-1.21,1.92,4.34,0,3.73-.91-1-1.51.2-2.72,2.73-2.83,2.33-4.54-2-1.32-.91-2.43,2.92-3,3.33-5.45.2-4.54-1.82-6.25-5.25-5.35-5.35-8.48a21.69,21.69,0,0,1-.4-7.27S636.56,283.17,635.75,288.22Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.38,268.94s-4.92,4.42-4.58,8.5.68,11.38,2,13.24,5.3,5.55,7.3,5.65c1.67.08,3.65-1.31,5-2.67s3-5.18,3.31-6,.34-10.19,0-12.06-5.77-6.12-7.81-6.63A16.74,16.74,0,0,0,645.38,268.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.06,287.41s1.42,1.08,2.25.75a5.25,5.25,0,0,0,1.58-1.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.73,289.41s4.5,2.33,7.25-1.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.56,280.15c1.5-1,3.75.34,3.75.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.64,280.15s2.34-1.58,4.17-.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.73,
    cy: 283.07,
    rx: 0.78,
    ry: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.93,282.65a.81.81,0,1,1-.78-1A.92.92,0,0,1,653.93,282.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.1,271.87s-3.93.71-5.45,3.43-1.81,6.56-4.94,9.19a24.09,24.09,0,0,1-6,3.73s-1-6.86.51-9.59,4.54-10.19,7.67-12,6.86-.91,7.47-.91,3.73-.2,5.65,2.22,2.93,7.27,3.63,9.19a33.1,33.1,0,0,1,1.52,8.78c0,2.52-1.21,4.74-2,5.25a10.27,10.27,0,0,1-2.73.81s1.62-9.19.91-10.3-2.52-4.54-4-6.56S652.1,271.87,652.1,271.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.09,313.34,647,324l4.81,3.32h4.72l-1.24-14.77a.87.87,0,0,0-.94-.81l-8.46.57A.88.88,0,0,0,645.09,313.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.61,332.74s7.19-7.64,8.71-9.63a14.65,14.65,0,0,1,4.89-3.74c.61-.23,5.89-.61,6.8-.77s2.07.16,1.76.85-.84,1-2.21,1.14a3.2,3.2,0,0,1-1.9-.18s1.28,4.08,1.05,4.54-4,2.14-5.42,2.67a6.79,6.79,0,0,1-2.22.54,68.73,68.73,0,0,1-2.9,8.55c-1.15,2.22-2.9,5.2-4.58,5.58s-3.75-.15-4.21-1.22a28.64,28.64,0,0,1-.91-7.41",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.07,328.16c-2-.23-2.67-2.68-2.67-2.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.91,326s-.87-3.76-1.14-4.46-3.23-3.4-3.58-3.93l-.35-.52.17,3.23a8,8,0,0,1,1,2.27,2,2,0,0,1-1.22,1.58c-.61.26-2.62-1.93-4.81-3.24s-4.54-3-5-2.36-.44,1.05.61,1.84a44,44,0,0,1,3.93,3.58,3.68,3.68,0,0,1,.53,1,37.25,37.25,0,0,1-3.67-2.18c-2.1-1.4-2.54-2.45-3-2.45s-1,.26-.35,1.49,1.22,2.53,1.22,2.53a6,6,0,0,0,1,2.62,22,22,0,0,0,6.29,4.55c2.45,1,11.63,4.46,15.21,4.9a10.34,10.34,0,0,0,7.7-2.63,30.38,30.38,0,0,0,1.92-4.37s2.54-14.33,2.1-21.5-3-8.66-4.72-9.09a20.31,20.31,0,0,0-5.33,0s.34,6.9.26,12.85-.88,14.51-.88,14.51-.7,1.22-3.23,1.66S661.78,327.31,660.91,326Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669,326.18s3.67-2.19,6.38.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.35,324.34a22.4,22.4,0,0,0,4.11,3.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640,345.75c-1.31,6.56.41,14.54.41,14.54h25.23a21.07,21.07,0,0,0,7.27-1.42c2.72-1.21,6.76-6.46,6.66-14.13a24.07,24.07,0,0,0-.43-3.93H641C640.68,342.38,640.33,344.05,640,345.75Z",
    style: {
      fill: "#8a8a8a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.16,345.17s-4.49-7.13-10.69-11.35-18.46-7-20.32-6.6c-4.08.94-6.59,5.28-8.7,9.11s-10,23.22-11.61,28.63-6.6,10.29-8.32,11.61-7.52,3.29-11.34,3.82-7.92.79-9.24,2.11.79,5.28,4.88,7.79,17.81,3.29,19.53,2.9,3.43-3.17,3.43-3.17,1.45-4.35,2.77-7.39,2.77-5.8,7.12-10.68,10.56-16.23,12.41-19.26,3.29-5.68,3.29-5.68,8,13.2,10.69,13.46,10.78.77,13.84-1.6",
    style: {
      fill: "#8a8a8a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.37,347a46.85,46.85,0,0,0,3.72-6.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.8,369.38a30.24,30.24,0,0,1-6.28,7.19c-1.71,1.32-7.52,3.29-11.34,3.82s-7.92.79-9.24,2.11.79,5.28,4.88,7.79,17.81,3.29,19.53,2.9,3.43-3.17,3.43-3.17,1.45-4.35,2.77-7.39a31.45,31.45,0,0,1,4.54-7.61C627.54,371.4,623.18,369.81,621.8,369.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.64,383.93a14.53,14.53,0,0,0-1.76-5.05,7.17,7.17,0,0,0-3.36-2.31c-1.73,1.32-7.52,3.29-11.34,3.82s-7.92.79-9.24,2.11.79,5.28,4.88,7.79,17.81,3.29,19.53,2.9,3.43-3.17,3.43-3.17.71-2.12,1.59-4.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.37,347s7.16,3.33,8.69,6a8.13,8.13,0,0,1,.58,6.46c-.35.94-2.58,3.64-2.93,4.7s2.35,12.57,2.7,21.73.35,17.74,1.05,20.44,2.12,6.11,2.47,8.57.94,5.88.24,6.93-1.77,1.06-1.88,1.65-.12,1.76-2.12,2.23-11,.23-11.51-.47,1.29-3.76,2-5.17a71.3,71.3,0,0,0,3.17-10.22c.47-2.47-1.06-6.22-1.29-6.58s-7.17-19.26-8.81-27.72-3.41-10.66-1.06-13.74C642.49,358.16,645.73,350.46,648.37,347Z",
    style: {
      fill: "#8a8a8a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.46,406.37a19,19,0,0,1-.4-2.94l-8,1a11.77,11.77,0,0,1,.81,5.44,71.3,71.3,0,0,1-3.17,10.22c-.71,1.41-2.47,4.46-2,5.17s9.52.94,11.51.47,2-1.65,2.12-2.23,1.17-.59,1.88-1.65.11-4.46-.24-6.93S659.17,409.07,658.46,406.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.63,410.11l-1.28.84a5.09,5.09,0,0,0-3.41-2.12c-2.37-.53-4,1.58-4.3,1.94a72.62,72.62,0,0,1-3,9.34c-.71,1.41-2.47,4.46-2,5.17s9.52.94,11.51.47,2-1.65,2.12-2.23,1.17-.59,1.88-1.65.11-4.46-.24-6.93A31.47,31.47,0,0,0,659.63,410.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.6,321.82h36.83s4.75-.3,6.09-3.57,3.71-8,2.67-13.06-5.2-9.86-5.2-9.86l-40.42-2.07s-4.27,2.57-5.16,10.29S532.55,318.4,537.6,321.82Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.51,253.53A25,25,0,0,1,589,265.91c-.28,7.56-.27,9-.27,9s1.51,5.33.82,8.77-4.68,10.59-4.68,10.59L578.13,282l.55-8.94S580.91,258.67,586.51,253.53Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.68,273.05l-.22,3.53a79.19,79.19,0,0,1,10.24-2.86c.07-1.83.17-4.41.29-7.81a25,25,0,0,0-2.48-12.38C580.91,258.67,578.68,273.05,578.68,273.05Z",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.44,244.18s-12,3.17-15.67,5.23-.55,15.67-.14,18.42-2.06,25.43-2.06,25.43,8.39,5.5,21.86,5.36S578,295.33,578,295.33s0-5.78.14-7.84.55-14.44.55-14.44,3.57-15.39,6.87-18.42l1-1.1s-2.5-4.64-11.83-6.58S561.49,243.5,555.44,244.18Z",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.44,
    cy: 250.15,
    rx: 9.21,
    ry: 10.66,
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.66,248.45s2.34,8.24.55,13.33-3.58,10.31-3.58,10.31l-3.43,14.44s10.31,8.25,16.77,10.17,6.32,3.85,7.15,4.67,6.46,9.35,6.74,10.45a69.14,69.14,0,0,1,.62,9.65c-.21.81-.71.51-1.11.31s-.81-2.12-.71-2.62a27.56,27.56,0,0,0-1.3,2.54c-.3.51-1.31.41-1.61.21s-.3-1.41-.2-2.22.3-2.32.3-2.32a15.78,15.78,0,0,1-1.21,2.92c-.5.71-.9,1.31-1.51,1.52s-1.71.1-1.41-.71-1.21.2-1.21-1-.6-5.84-.8-6.95a8.88,8.88,0,0,0-1-2.42l-1.51-3.93-.61-2.42s-23-5.94-25.19-6.95a3.58,3.58,0,0,1-2.32-3.33c-.1-.7,0-10.48.4-15.21s3.06-12,3.66-14.23,2.74-8.63,3.84-10.24S537.67,248.29,542.66,248.45Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.2,286.53s-4.6-1.67-5.55-2.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "558.72 321.1 559.93 317.17 559.93 313.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.85,317.37s.1-2.12.1-3.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.66,319.16a22.72,22.72,0,0,0,.12-3,17.66,17.66,0,0,0-.81-2.42",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.4,301.92s-10.84-7.57-14.84-8.91-8,4.42-9.71,7.35c-1.8,3.11,2.32,13,6.47,24.41,4,11.06,7.31,20.42,7.31,20.42l10.55,1s-4-10.2-4-15.28c0-3.53-2.23-11.48-1.17-11.47,0,0,5.57-3.6,6.46-7.91S543.4,301.92,543.4,301.92Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.75,318.25l1-12.32a9.43,9.43,0,0,0-2-4.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.05,274.21a63.45,63.45,0,0,1-5.46,4.42c-.9.4-4.07,8.54-5.52,9.93-3.26,3.13-9,2.74-9.78,2-2-1.9-1.9-5.7-1.76-6.52s4.48-4.05,5.56-4.73,6.17-4.11,6.17-4.11l1.41-3.34,6.27-1.93Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "598.68 273.72 589.8 272.84 594.85 253.91 603.73 254.8 598.68 273.72",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.36,275a4.8,4.8,0,0,0-.36,2,4.17,4.17,0,0,0,1.24,1.59",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.38,262.49a28.94,28.94,0,0,0-.61-4.38c-.31-.6-3.91-2.06-4.45-2.16s-1.88.5-1.88,1.33,2.51,1.4,2.51,1.4l1.7,1.27-.17,1.76,1.81,2.24Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.73,263.65s-2.36-3.85-3.08-3.7-5.08,1.45-5.57,1.91-.19,1.9-.19,1.9l1.88.06s-2.28,1.39-2.31,2.35l0,1a6.56,6.56,0,0,1,1.9.19c.51.23-1.49,1.39-.94,2.18.23.33,2.45.82,3.56,1.73a6.94,6.94,0,0,1,2.1,3S603.36,267.31,603.73,263.65Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.77,263.82a8.14,8.14,0,0,1,3-.18c.91.3,2.79,3,2.79,3",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "596.33 267.32 598.94 267.36 601.59 270.31",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.71,289.07s-6.42,7.43-7.46,13.67-.29,8.9,1.19,10.54,4.75,2.37,4.75,2.37a18.4,18.4,0,0,1,3.15,6.83A72.61,72.61,0,0,0,587,331.1l-.3,15.14.15,2.38,8.91-2.23L597,333.32s3.56-21.38,1.63-27.77-3.71-14.85-5.35-16.48S584.79,287.44,582.71,289.07Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.89,285.43c.7.33,1.43.67,2.2,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.08,277.49s2.59,3,9.07,6.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.08,286.7s1.74,4,12.15,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.14,281.72a30.46,30.46,0,0,1-6.24,2.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.3,292.57s-8.4,2.13-15.61,1.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.19,315.65c-1.27-1.49-2.51-14.33,0-14.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.26,270.28c.67-2,1.81-5.26,3-8.5,1.79-5.09-.55-13.33-.55-13.33-5-.16-7.58,4.34-8.69,6s-3.23,8-3.84,10.24c-.15.58-.45,1.51-.82,2.64Z",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.18,346.23a48,48,0,0,0-5.35-4c-1.48-.75-2.22-.26-3.7.78s-4,4.86-5.06,6.79a45,45,0,0,1-2.82,4.75c-1.49,2.23-1.34,4.31-.45,5.64s7.87,1.64,10.7,1.34a11.75,11.75,0,0,0,6.53-3.42c.89-1,1-5.49,1-6.38S543.18,346.23,543.18,346.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543,358.11a8.3,8.3,0,0,0,.89-3.61,22.35,22.35,0,0,1-7.15,4.35c-3.73,1.34-9.34.44-11.52,0a4,4,0,0,0,.55,1.34c.89,1.34,7.87,1.64,10.7,1.34A11.75,11.75,0,0,0,543,358.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.67,351.3s-.38,6.6-1.7,8.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.71,348.32s-.3-3.41-2.82-4-5.64.74-6.24,1.49-1.93.44-1.93.44-.74.15-1.63,3.12-1.49,6.09-1,7.43-.3,1.48,1,2.07a36,36,0,0,0,4.3,1.34,4.59,4.59,0,0,0,3,2.08c1.79.15,9.36.44,10.4-.15a4.82,4.82,0,0,0,1.48-5.34C603.35,354.56,597.71,350,597.71,348.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.79,360.38c-5.28.37-8.67-.94-9.81-1.89-.78-.65-4-1.3-5.91-1.64.4,1.27-.3,1.43,1,2a36,36,0,0,0,4.3,1.34,4.59,4.59,0,0,0,3,2.08c1.79.15,9.36.44,10.4-.15a4.31,4.31,0,0,0,1.6-2.51A20.82,20.82,0,0,1,599.79,360.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.66,352.46a47.92,47.92,0,0,1,.73,7.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549,261.41c-1.91,2.71-4.51,5.87-7.06,7.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,256.77s-.51.91-1.35,2.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.3,259.41a20.54,20.54,0,0,1-3.2,5.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.29,239s2.11-.78,2.36,1-1.49,4.93-2.62,5.67-1.31-.14-1.31-.14Z",
    style: {
      fill: "#bababa",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558,237.29s-.54-3.27-2.11-1.52-1.12,6.08-.5,7.18a3.11,3.11,0,0,0,2.31,1.19s.5,1,1.93,4,4.78,7.93,8.72,8.25,6.09-1.78,8.24-6c1.3-2.54,2.94-5,3.05-9.7s.76-4.33,1-9.25,1.27-8-.2-9.75-8.78-3.37-14.15-2.64-7.07,1.35-7.68,3.77S558,237.29,558,237.29Z",
    style: {
      fill: "#bababa",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.18,237.38a3.48,3.48,0,0,0-4.83.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.33,237.85c.28-.34,2.41-1.43,4,1.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.48,242.54a5.69,5.69,0,0,1-2.8,1.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.78,243.48a4.49,4.49,0,0,0,2.51,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.76,238.06a61.1,61.1,0,0,0,.87-6.59c.28-4.92,1.27-8-.2-9.75s-8.78-3.37-14.15-2.64-7.07,1.35-7.68,3.77c-.53,2.08-.62,11.15-.63,13.74l.09.23a11,11,0,0,0,0,2.8c.23.66,1.13,1,1.37-.2s-.14-4.65.7-5.81.59-3.52,1.93-5.31,5-.57,6.9.68,2.35,1.57,4.66,1,3.42-1.86,5.11-.66,1.23,2.92,1,5.06A14.21,14.21,0,0,0,579.76,238.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.37,241.78l-.19,1.54s1,.56.34,2.49-2.15,2.24-3.55,1.34-.69-2-.69-2",
    style: {
      fill: "#bababa",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.85,240.87c0,.62-.34,1.11-.67,1.09s-.56-.54-.52-1.16.33-1.11.66-1.09S565.88,240.25,565.85,240.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.92,241.52c-.12.61-.48,1-.8,1s-.48-.62-.36-1.23.49-1.05.81-1S575.05,240.91,574.92,241.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.14,247.68c-.12.92,3,5.71,7.43,1.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.1,307.77c-.51-.91-5.56-5.2-5.56-5.2L445,290l1.23,12.74,14.44,3.67,1.73.88,4.56,2.55.48,3.7s-2,1-1.73,1.65,1.73.87,2.3,1.37,1.39.22,1.88.13a.34.34,0,0,0,.3-.07,17.85,17.85,0,0,0,2.05-1.91S471.6,308.67,471.1,307.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.02 291.73 446 304.34 441.85 301.63 444.95 289.98 450.02 291.73",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,306.5a14.62,14.62,0,0,1,1.79,2.43c.24.67,1.82,5.78,1.82,5.78s-1.38,1.58-2,.26a29.88,29.88,0,0,1-1.26-4.09,7.11,7.11,0,0,1-3.12-2.53,13.14,13.14,0,0,1-1.26-3.48",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.08,320.51a53.19,53.19,0,0,0,.26,5.87c.27,1.06,1.21,8,1.21,8s-8.14,37.61-9.74,41.35-8.67,22.67-10.13,27.34-3.6,7.2-2.67,8.4l.94,1.2s-4.54,8.94-3.74,9.47,9.74,2.94,15.34,3.2,13.87.94,14.4,0,.8-2.8,0-3.33-4.26-1.47-5.6-2.67-4.93-5.47-4.93-5.47a13.21,13.21,0,0,0,1.46-3.46,35.2,35.2,0,0,1,.94-5.07c.4-.8,12.4-28.68,12.93-32s9.12-26.19,9.12-26.19,5.14,16.88,6.2,20.48,9.65,42.8,9.65,43.47.13,2.4.53,2.8l.94.93s1.73,8,1.73,8.41a1.84,1.84,0,0,0,1.74,2.13c1.86.27,13.07-.67,14.8-.67s5.07-1.47,6.54-2.4,2.13-2.8.93-3.2-6-.53-7.87-1.2-4.94-4.27-4.94-4.27a19,19,0,0,0,.67-2.4c0-.4-3.33-5.33-3.33-5.73s-4.75-46.67-4.75-46.67-9.42-33.24-9.42-33.64-1.34-6.8-1.34-6.8-8-7.33-11.73-7.47.66-1.73-9.07,1.07S411.08,320.51,411.08,320.51Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,236.88s-11.6,14.81-12,17.21-1.07,14.8-1.07,15.47-.13,23.34-.13,23.34l.53,20,.54,9.33s10.4-4.27,13.07-5.47,5.87-2.53,6.53-2.8,10.14,3.87,11.21,4.53,5.33,4,5.33,4,1.6-22,1.07-25.48-1.87-35.61-1.87-35.61l-9.34-15.61Z",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.88,
    y1: 279.96,
    x2: 429.35,
    y2: 299.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.71,218.71a39.53,39.53,0,0,1-.42,5.81l-.38,1.43s2,4.57,1.58,5a23.82,23.82,0,0,1-3,1.6s-3.6,9.05-4.55,9.7-8.38-1.94-8.38-1.94l-4.05,2.92-7.91-9.43,1.25-3.8s-.38-18.33.31-19.07,9.41-5.5,13.35-4.62,9.32,2.84,11.43,4.47,4.86,5.33,3.57,6.14S451.71,218.71,451.71,218.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.32,232.45s2.88,2.63,4.72,2.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.51,216.9c1.29-.81-1.47-4.52-3.57-6.14s-7.49-3.6-11.43-4.47-12.65,3.88-13.35,4.62-.31,19.07-.31,19.07l-.08.24,6.53-2.71,1.24-3.38,3.32-.92s4.75-1,5-2.3.75-5.55.75-5.55l9.14,3.35S453.22,217.7,454.51,216.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.07,224.49s-.16-3-2.5-2.84-3.71,3.37-2.27,5.86,2.94,1.15,2.94,1.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.17,226.44c-.21.58-.69.95-1.07.81s-.52-.73-.3-1.32.7-1,1.08-.81S448.39,225.85,448.17,226.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.39,223.16s2.12-.36,3,1.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.61 233.68 436.81 241.95 437.02 247.92 419.72 238.75 423.61 233.68",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.36,256.31l3,7.86a45.84,45.84,0,0,1,3.92,3c.91.9,3.72,7.51,3.72,7.51l5.46-.37,6.37,7.65s-12.57,11.09-18,10.18-23.44-30.09-23.74-32.81,1.31-10.15,1.31-10.15,2.95-5.24,6.87-5.24",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.81 256.14 475.35 246.41 477.06 247.3 465.9 257.91 464.81 256.14",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.69,272.46l9-8.17a46.46,46.46,0,0,1,.44-5.69c.32-1.18,2.37-3.11,2.64-3.92s.59-4.13,1.34-4,1.29,1.18,1.34,1.88a18.77,18.77,0,0,1-.43,3l-.11,2.37,6.39-5.53,1.08,1.62a14.36,14.36,0,0,0-.7,1.66c-.27.8-.65,5-.87,6s-6.29,6.38-6.29,6.38L458,279.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.22 274.57 455.37 284.9 459.39 279.75 451.32 270.8 446.22 274.57",
    style: {
      fill: "#F2F2D8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutus);
export default __webpack_public_path__ + "static/media/aboutus.84e12100621df35a38016c535f1a130f.svg";
export { ForwardRef as ReactComponent };